import Vue from 'vue'
// import PrintPosFacturaTicketModular from "../components/ReportsAndPrintings/PrintPosFacturaTicketModular.vue";
import PrintPosFacturaTicketModular from "../components/ReportsAndPrintings/PrintPosFacturaTicketModular2.vue";
import PrintPosFacturaTicketModular99Store from "../components/ReportsAndPrintings/PrintPosFacturaTicketModular99Store.vue";
import PrintPosFacturaTicketV2 from "../components/ReportsAndPrintings/PrintPosFacturaTicketV2.vue";
import PrintPosTkModular from "../components/ReportsAndPrintings/PrintPosTkModular.vue";
import PrintPosFaMedModular from "../components/ReportsAndPrintings/PrintPosFaMedModular.vue";
import PrintPosFacturaSolAmbientalModular from "../components/ReportsAndPrintings/PrintPosFacturaSolAmbientalModular.vue";
import PrintPosFaModular from "../components/ReportsAndPrintings/PrintPosFaModular.vue";
import PrintPosFacturaTicketComandas from '../components/ReportsAndPrintings/PrintPosFacturaTicketComandas.vue';
import PrintPosDteLetter from "../components/ReportsAndPrintings/PrintPosDteLetter.vue";
import { loadGuaranteeHtml } from "../components/ReportsAndPrintings/utils/guaranteePlacement";
import { resolveBranchConfiguredDteTemplate } from "../helpers/dteTemplateSettings";

// Bandera para evitar ejecuciones múltiples
let isImprimiendoFactura = false;

export async function imprimirFactura(ID_Invoice, vueInstance = null, options = {}) {
  // Verificar si ya se está ejecutando la función
  // console.log('vueInstance', vueInstance);
  if (isImprimiendoFactura) {
    console.log('La impresión ya está en progreso, ignorando nueva solicitud...');
    return;
  }

  // Activar la bandera
  isImprimiendoFactura = true;

  try {
    // Usar la instancia de Vue si se proporciona, sino usar el API importado directamente
    const invoiceApi = vueInstance.$API;
    
    // Obtener datos principales
    const invoice = await invoiceApi.invoices.getInvoice(ID_Invoice);

    // Obtener información de usuario y sucursal básica
    const userinfo = JSON.parse(localStorage.getItem("user"));
    let branchinfo = JSON.parse(localStorage.getItem("branch"));
    
    // Obtener información completa de la sucursal como en InvoiceDetails
    const searchbusiness = {
      branch: userinfo.branch || "",
      business: userinfo.businessid || ""
    };

    // Obtener datos adicionales necesarios como en InvoiceDetails
    const [
      invoiceProductItems,
      invoiceServiceItems,
      invoicePayments,
      dteJsonHeader,
      docRelated,
      infobusiness
    ] = await Promise.all([
      invoiceApi.invoices.getInvoiceProductItems(ID_Invoice),
      invoiceApi.invoices.getInvoiceServiceItems(ID_Invoice),
      invoiceApi.invoices.getInvoicePayments(ID_Invoice),
      invoiceApi.invoices.getDteJsonHeaderByInvoice(ID_Invoice).catch(() => []),
      invoice.InvoiceType === 'DNC' || invoice.InvoiceType === 'DND' 
        ? invoiceApi.invoices.getDocRelatedByInvoice(ID_Invoice).catch(() => [])
        : Promise.resolve([]),
      invoiceApi.branches.findSpecificBranch(searchbusiness)
    ]);

    // Completar branchinfo con datos de infobusiness como en InvoiceDetails
    if (infobusiness && infobusiness.length > 0) {
      const businessData = infobusiness[0];
      branchinfo.AuthFeMode = businessData.AuthFeMode;
      branchinfo.BusinessBillingNRC = businessData.BusinessBillingNRC;
      branchinfo.BusinessBillingNIT = businessData.BusinessBillingNIT;
      branchinfo.BusinessBillingName = businessData.BusinessBillingName;
    }

    // Combinar items de productos y servicios
    const invoiceItems = [...invoiceProductItems, ...invoiceServiceItems];
    
    // Obtener información del DTE
    const invoiceDteJson = dteJsonHeader.length > 0 ? dteJsonHeader[0] : {};
    
    // Procesar pagos
    const processedPayments = invoicePayments ? invoicePayments.map(payment => ({
      ...payment,
      TotalPayment: parseFloat(payment.TotalPayment).toFixed(2)
    })) : [];

    const ticketGuaranteeHtml = await loadGuaranteeHtml(
      { $API: invoiceApi },
      {
        businessId: userinfo.businessid,
        branchId: branchinfo.ID_Branch,
        guaranteeType: "TICKET",
      }
    );

    const shouldUseNativeDteTemplate = Boolean(options.useNativeDteTemplate);
    const dteTemplateResolution = !shouldUseNativeDteTemplate || invoice.ID_Invoice.startsWith("TCKS")
      ? { eligible: false }
      : await resolveBranchConfiguredDteTemplate(invoiceApi, branchinfo);

    if (dteTemplateResolution.eligible) {
      const printData = {
        show: true,
        businessId: userinfo.businessid,
        branchId: branchinfo.ID_Branch,
        guaranteeHtml: ticketGuaranteeHtml,
        data: {
          header: { ...invoice, ...invoiceDteJson },
          user: userinfo,
          body: invoiceItems,
          branch: branchinfo,
          dteJson: invoiceDteJson,
          docRelated: docRelated,
          invoicePayments: processedPayments
        },
      };

      await imprimirDteTemplateDataObjeto(printData, false);
      return;
    }

    // Verificar si debe usar formato FCF
    const shouldUseFCFFormat = userinfo.ticketformatfcf &&
      (
        ( userinfo.TipoPlan !== "Emprendedor" &&
          userinfo.TipoPlan !== "Ecoanual" 
        ) || userinfo.preferentialplan == 1
      )
      && (invoice.InvoiceType === "FCF" || invoice.InvoiceType === "CCF");

    if (shouldUseFCFFormat) {
      // Preparar datos para formato FCF igual que en InvoiceDetails
      const printData = {
        show: true, // Cambiar a true
        businessId: userinfo.businessid,
        branchId: branchinfo.ID_Branch,
        guaranteeHtml: ticketGuaranteeHtml,
        data: {
          header: { ...invoice, ...invoiceDteJson },
          user: userinfo,
          body: invoiceItems,
          branch: branchinfo,
          dteJson: invoiceDteJson,
          docRelated: docRelated,
          invoicePayments: processedPayments
        },
      };

      const keyMaster = infobusiness[0].ID_KeyMaster;
      
      if(!options.regularPrint && vueInstance.posrestaurant === 1 && vueInstance.orderAndPrint === true ? true : false) {
        await imprimirFacturaDataObjeto(printData, false, PrintPosFacturaTicketComandas, {
          windowSize: { width: screen.width, height: screen.height },
          pageSize: 76 * 2.83465,
          scale: 0.675,
          timeout: 0
        });
        if (vueInstance?.print?.show) {
          vueInstance.print.show = false;
        }
        return;
      }
      const useNormalTicketV2 = [true, 1, "1"].includes(userinfo.usenormalticketv2);
      const usecompactticket = JSON.parse(localStorage.getItem('user'))?.usecompactticket ?? 0;

      if (useNormalTicketV2) {
        await imprimirFacturaDataObjeto(printData, false, PrintPosFacturaTicketV2, {
          windowSize: { width: screen.width, height: screen.height },
          pageSize: 76 * 2.83465,
          scale: 0.675,
          timeout: 0,
          printOnly: true,
          renderDelay: 300
        });
      } else if(['bf4246b7d9d825f2b2ec3cff6a2e4372', '4a43e4148cddec0e59685f67673955ba', 'ac296667317cfa35356801db4dc039b3'].includes(keyMaster) || usecompactticket) {
        await imprimirFacturaDataObjeto(printData, false, PrintPosFacturaTicketModular99Store, {
          windowSize: { width: screen.width, height: screen.height },
          pageSize: 76 * 2.83465,
          scale: 0.675,
          timeout: 0
        });
      } else {
        // Usar la función parametrizada para FCF
        await imprimirFacturaDataObjeto(printData, false, PrintPosFacturaTicketModular, {
          windowSize: { width: screen.width, height: screen.height },
          pageSize: 76 * 2.83465,
          scale: 0.675,
          timeout: 0
        });
      }

      
    } else {
      // Preparar datos para otros formatos
      const printData = {
        show: true, // Cambiar a true
        businessId: userinfo.businessid,
        branchId: branchinfo.ID_Branch,
        guaranteeHtml: ticketGuaranteeHtml,
        data: {
          header: { ...invoice, ...invoiceDteJson },
          user: userinfo,
          body: invoiceItems,
          branch: branchinfo,
          dteJson: invoiceDteJson,
          docRelated: docRelated,
          invoicePayments: processedPayments
        }
      };

      // Determinar el componente según ID_KeyMaster y tipo de factura
      let PrintComponent;
      let printConfig;

      if (invoice.ID_Invoice.startsWith("TCKS") || invoice.InvoiceType == 'TCKS') {
        PrintComponent = PrintPosTkModular;
        printConfig = {
          windowSize: { width: screen.width, height: screen.height },
          pageSize: 76 * 2.83465,
          scale: 1,
          timeout: 0
        };
      } else {
        // Seleccionar componente según ID_KeyMaster como en InvoiceDetails
        if (infobusiness && infobusiness.length > 0) {
          const keyMaster = infobusiness[0].ID_KeyMaster;
          
          if (keyMaster === 'e05f325e05113060116d3d03ea7de431') {
            PrintComponent = PrintPosFaMedModular;
          } else if (keyMaster === '7accd5a9b298117d5fd9b94c54d8f97f') {
            PrintComponent = PrintPosFacturaSolAmbientalModular;
          } else {
            PrintComponent = PrintPosFaModular;
          }
        } else {
          PrintComponent = PrintPosFaModular; // Por defecto
        }

        printConfig = {
          windowSize: { width: screen.width, height: screen.height },
          pageSize: 612, // Letter width
          scale: 1,
          timeout: 0
        };
      }

      await imprimirFacturaDataObjeto(printData, false, PrintComponent, printConfig);
    }
  } catch (error) {
    console.error('Error al imprimir la factura:', error)
    alert('No se pudo cargar la factura para imprimir.')
  } finally {
    // Desactivar la bandera al finalizar (éxito o error)
    isImprimiendoFactura = false;
  }
}

export async function imprimirFacturaDataObjeto(print, hideQr, PrintComponent, printConfig = {}) {
  try {
    // Configuración por defecto
    const config = {
      windowSize: { width: screen.width, height: screen.height },
      pageSize: 76 * 2.83465,
      scale: 0.675,
      timeout: 600,
      loadTimeout: 10000, // Timeout de 10 segundos para carga de recursos
      ...printConfig
    };

    const Component = Vue.extend(PrintComponent);
    const instancia = new Component({
      propsData: {
        dataProps: print,
        hideQr: hideQr || false,
        type: 'ticket',
        printOnly: Boolean(config.printOnly)
      }
    }).$mount();

    await Vue.nextTick();
    
    const printWindow = window.open('', '', `width=${config.windowSize.width},height=${config.windowSize.height}`);
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    Vue.nextTick(async () => {
      if (config.renderDelay) {
        await new Promise((resolve) => setTimeout(resolve, config.renderDelay));
      }

      let htmlContent = '';

      const cssPath = `/css/invoices/${PrintComponent.name}.css`;
      
      if (config.pageSize && config.scale) {
        // Configuración para ticket/FCF con tamaño específico
        htmlContent = `
          <html>
            <head>
              <link rel="stylesheet" href="${cssPath}">
              <style>
                body {
                  margin: 0;
                  padding: 0;
                }
              </style>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
            </head>
            <body>
              ${instancia.$el.outerHTML}
            </body>
          </html>
        `;
      } else {
        // Configuración para factura regular
        htmlContent = `
          <html>
            <head>
              <title>Factura</title>
              <style>
                body { font-family: sans-serif; }
              </style>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
            </head>
            <body>${instancia.$el.outerHTML}</body>
          </html>
        `;
      }

      printWindow.document.write(htmlContent);
      printWindow.document.close();

      // Función para verificar si todas las imágenes están cargadas
      const waitForResources = () => {
        return new Promise((resolve) => {
          const images = printWindow.document.getElementsByTagName('img');
          let loadedImages = 0;
          const totalImages = images.length;

          // Si no hay imágenes, resolver inmediatamente
          if (totalImages === 0) {
            resolve();
            return;
          }

          // Timeout de seguridad
          const timeoutId = setTimeout(() => {
            resolve();
          }, config.loadTimeout);

          // Función para verificar si todas las imágenes están cargadas
          const checkAllLoaded = () => {
            if (loadedImages === totalImages) {
              clearTimeout(timeoutId);
              resolve();
            }
          };

          // Agregar listeners a todas las imágenes
          Array.from(images).forEach((img) => {
            if (img.complete) {
              loadedImages++;
            } else {
              img.onload = () => {
                loadedImages++;
                checkAllLoaded();
              };
              img.onerror = () => {
                loadedImages++;
                checkAllLoaded();
              };
            }
          });

          // Verificar si ya están todas cargadas
          checkAllLoaded();
        });
      };
      // Esperar a que el documento y todos los recursos estén cargados
      if (printWindow.document.readyState === 'complete') {
        Promise.all([
          waitForAllStylesheets(printWindow),
          waitForResources() // Your existing image loading wait function
        ]).then(() => {
          setTimeout(() => {
            printWindow.focus();
            //Hacer que espere a cargar la pagina para los moviles.
            if (isMobile) {
               setTimeout(()=>{
                printWindow.print()
              }, 2000);
            }else{
              printWindow.print()
              printWindow.close();
            }
           
           //
          }, config.timeout);
        });
      } else {
        printWindow.addEventListener('load', () => {
        Promise.all([
          waitForAllStylesheets(printWindow),
          waitForResources() // Your existing image loading wait function
        ]).then(() => {
            setTimeout(() => {
              printWindow.focus();
              //Hacer que espere a cargar la pagina para los moviles.
              if (isMobile) {
                setTimeout(()=>{
                  printWindow.print()
                }, 2000);
              }else{
                printWindow.print()
                printWindow.close();
              }
            }, config.timeout);
          });
        });
      }
    });
  } catch (error) {
    console.error('Error al imprimir la factura:', error);
    alert('No se pudo cargar la factura para imprimir.');
  }
}

export async function imprimirDteTemplateDataObjeto(print, hideQr = false) {
  const Component = Vue.extend(PrintPosDteLetter);
  const instancia = new Component({
    propsData: {
      dataProps: print,
      hideQr,
    }
  }).$mount();

  try {
    await Vue.nextTick();
    if (typeof instancia.refreshDocument === "function") {
      await instancia.refreshDocument({ resetLayout: true });
    }
    await Vue.nextTick();
    await new Promise((resolve) => setTimeout(resolve, 350));

    if (typeof instancia.printDocument === "function") {
      await instancia.printDocument();
    }

    await new Promise((resolve) => setTimeout(resolve, 800));
  } finally {
    if (instancia && instancia.dataProps) {
      instancia.dataProps.show = false;
    }

    if (instancia && typeof instancia.$destroy === "function") {
      instancia.$destroy();
    }
  }
}

function waitForAllStylesheets(win, timeout = 10000) {
  return new Promise((resolve) => {
    const links = win.document.querySelectorAll('link[rel="stylesheet"]');
    const total = links.length;
    if (total === 0) {
      resolve();
      return;
    }

    let loadedCount = 0;
    let called = false;

    const onLoadHandler = () => {
      loadedCount++;
      if (loadedCount >= total && !called) {
        called = true;
        resolve();
      }
    };

    // Safety timeout to avoid hanging forever
    setTimeout(() => {
      if (!called) {
        called = true;
        resolve();
      }
    }, timeout);

    links.forEach((link) => {
      if (link.sheet) {
        // Already loaded
        onLoadHandler();
      } else {
        link.addEventListener('load', onLoadHandler);
        link.addEventListener('error', onLoadHandler);
      }
    });
  });
}
